import { range } from "lodash"
import { ArcherContainer, ArcherElement } from "react-archer"
import Figure from "../../curves/figure"

export default class GroupConv extends Component {
  render() {
    const neuron1Size = 10
    const neuron2Size = 40
    const neuron1Count = 16
    const letters = "abcdefgjijklmnop".split("")
    const rotations = 10
    const Header = ({ children }) => (
      <Surface width={320} borderBottom marginBottom={20}>
        <Text size={600} marginBottom={5}>
          {children}
        </Text>
      </Surface>
    )

    return (
      <Figure>
        <Surface
          width={1200}
          flexFlow="row"
          flexWrap="wrap"
          justifyContent="center"
          alignSelf="center"
        >
          <ArcherContainer strokeColor="rgba(0, 0, 0, 0.4)">
            <Surface flexFlow="row" alignItems="center">
              <Surface marginTop={20}>
                <Header>Group Convolutional Neural Network</Header>
                <Surface>
                  <Surface flexFlow="row" alignItems="center">
                    <Text size={400} width={350} marginRight={50}>
                      Half of the units are trained normally.
                      <br />
                      <br />
                      Additionally, several "rotation invariant" units have 16
                      rotations applied to them. This saves parameters and
                      encourages the model to take advantage of natural
                      invariances in the data.
                    </Text>
                    <ArcherElement
                      id="weights"
                      relations={[
                        {
                          targetId: "concat",
                          targetAnchor: "left",
                          sourceAnchor: "right",
                        },
                      ]}
                    >
                      <Text fontWeight={600}>Normal Units</Text>
                      <Surface
                        flexFlow="row"
                        width={neuron1Size * neuron1Count + 2}
                        height={neuron1Size * neuron1Count + 2}
                        flexWrap="wrap"
                        marginY={5}
                        border
                      >
                        {range(neuron1Count).map(y =>
                          range(neuron1Count).map(x => (
                            <Surface
                              background={"black"}
                              borderRadius={2}
                              opacity={Math.random() * 0.8}
                              width={neuron1Size}
                              height={neuron1Size}
                              border
                            />
                          )),
                        )}
                      </Surface>
                    </ArcherElement>
                  </Surface>
                  <Surface flexFlow="row" marginTop={20} alignItems="center">
                    <Surface>
                      <ArcherElement
                        id="rotoWeights"
                        relations={[
                          {
                            targetId: "transformed",
                            targetAnchor: "left",
                            sourceAnchor: "right",
                            label: <Text marginTop={-20}>transforms</Text>,
                          },
                        ]}
                      >
                        <Surface>
                          <Text fontWeight={600} marginBottom={5}>
                            Rotation Invariant Units
                          </Text>
                          <Surface
                            flexFlow="row"
                            flexWrap="wrap"
                            width={neuron2Size * 4}
                          >
                            {range(neuron1Count).map(i => (
                              <Surface
                                padding={5}
                                background="white"
                                border
                                justifyContent="center"
                                alignItems="center"
                                width={neuron2Size}
                                height={neuron2Size}
                              >
                                <Text fontSize={30} fontWeight={600}>
                                  {letters[i].toUpperCase()}
                                </Text>
                              </Surface>
                            ))}
                          </Surface>
                        </Surface>
                      </ArcherElement>
                    </Surface>
                    <Surface marginLeft={120}>
                      <ArcherElement
                        id="transformed"
                        relations={[
                          {
                            targetId: "concat",
                            targetAnchor: "left",
                            sourceAnchor: "right",
                          },
                        ]}
                      >
                        <Surface>
                          {range(rotations).map(rotation => (
                            <Surface flexFlow="row">
                              {range(neuron1Count).map(i => (
                                <Surface
                                  padding={5}
                                  background="white"
                                  border
                                  justifyContent="center"
                                  alignItems="center"
                                  width={20}
                                  height={20}
                                >
                                  <Text
                                    size={400}
                                    fontWeight={600}
                                    style={{
                                      transform: `rotate(${(360 / rotations) *
                                        rotation}deg)`,
                                    }}
                                  >
                                    {letters[i].toUpperCase()}
                                  </Text>
                                </Surface>
                              ))}
                            </Surface>
                          ))}
                        </Surface>
                      </ArcherElement>
                    </Surface>
                  </Surface>
                </Surface>
              </Surface>
              <Surface marginLeft={120}>
                <ArcherElement id="concat">
                  <Surface>
                    <Surface
                      alignSelf="center"
                      alignItems="center"
                      justifyContent="center"
                      borderRadius={30}
                      style={{ border: "2px solid rgba(0, 0, 0, 0.4)" }}
                      width={30}
                      height={30}
                    >
                      <Text size={20} transform="translate(0px, -1px)">
                        +
                      </Text>
                    </Surface>
                  </Surface>
                </ArcherElement>
              </Surface>
              <Text marginLeft={20}>Both unit groups are concatenated</Text>
            </Surface>
          </ArcherContainer>
        </Surface>
      </Figure>
    )
  }
}
